import ezikePic from "@/public/images/artists/ezike.png";
import { Artist } from "@/types/types";

export const ezike = {
  id: "235",
  name: "Ezike",
  image: ezikePic,
  description: `Ezike's voice is bright and agile, with effortless runs and falsetto. Comfortable across a wide range, he moves easily from rich mid-tones to soaring highs, perfect for energetic Afrobeat hooks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fezike-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Falsetto", "Afrobeat"],
      secondary: ["Amapiano"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 52,
        high: 73,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
